export default function () {
  const wpcf7 = window.document.querySelectorAll('.wpcf7');

  function closeAll(form) {
    form.querySelectorAll('.form__item--float').forEach((item) => {
      if (item.querySelector('input')) {
        if (item.querySelector('input').value) {
          return;
        }
      }

      if (item.querySelector('.choices__item')) {
        if (item.querySelector('.choices__item').dataset.value) {
          return;
        }
      }

      item.querySelector('.form__label').classList.remove('open');
    });
  }

  const getSHA256Hash = async (input) => {
    const textAsBuffer = new TextEncoder().encode(input);
    const hashBuffer = await window.crypto.subtle.digest('SHA-256', textAsBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hash = hashArray.map((item) => item.toString(16).padStart(2, '0')).join('');
    return hash;
  };

  document.addEventListener('DOMContentLoaded', () => {
    wpcf7.forEach((form) => {
      form.querySelectorAll('.form__item--float').forEach((item) => {
        const input = item.querySelector('input');
        const label = item.querySelector('.form__label');
        const choices = item.querySelector('.choices');

        if (input) {
          if (input.value) {
            label.classList.add('open');
          }

          input.addEventListener('focus', () => {
            closeAll(form);

            label.classList.add('open');
          });
        }

        if (item.querySelector('.choices__item')) {
          if (item.querySelector('.choices__item').dataset.value) {
            label.classList.add('open');
          }
        }

        item.addEventListener('click', () => {
          closeAll(form);

          label.classList.add('open');
        });

        if (choices) {
          choices.addEventListener('blur', () => {
            closeAll(form);
          });

          choices.addEventListener('focus', () => {
            closeAll(form);

            label.classList.add('open');
          });
        }
      });

      window.addEventListener('click', (event) => {
        if (!event.target.closest('.form__item--float')) {
          closeAll(form);
        }
      });

      form.addEventListener('wpcf7mailsent', async ({ detail }) => {
        closeAll(form);
        window.dataLayer.push({ event: 'contactForm' });

        if (detail.inputs.some((el) => el.name === 'form-slug' && el.value === 'signup')) {
          const email = detail.inputs.filter((el) => el.name === 'email')[0];
          const emailHash = await getSHA256Hash(email.value);
          window.dataLayer.push({
            event: 'newsletter_subscribe',
            sha256: emailHash,
          });
        }
      }, false);
    });
  });
}
